import { computed, inject, Injectable, Signal, signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { createActionResponseFactory } from '@core/ngrx-legacy';
import {
  TellentAssistantSuggestionsActions,
  TellentAssistantSuggestionsSelectors,
} from '@core/tellent-assistant-data';
import {
  bannerSlotKey,
  type BannerSlot,
  type BannerSuggestions,
} from '@core/tellent-assistant-types';

@Injectable({ providedIn: 'root' })
export class SuggestionsDataService {
  private readonly store = inject(Store);
  private readonly response = createActionResponseFactory(TellentAssistantSuggestionsActions);
  private readonly dismissedSlots = signal<ReadonlySet<string>>(new Set());

  public bySlot(slot: BannerSlot): Signal<BannerSuggestions | null> {
    return this.store.selectSignal(TellentAssistantSuggestionsSelectors.byId(bannerSlotKey(slot)));
  }

  public isDismissed(slot: BannerSlot): Signal<boolean> {
    const key = bannerSlotKey(slot);
    return computed(() => this.dismissedSlots().has(key));
  }

  public dismiss(slot: BannerSlot): void {
    this.dismissedSlots.update(keys => new Set(keys).add(bannerSlotKey(slot)));
  }

  public loadSuggestions(slot: BannerSlot) {
    return this.response(
      TellentAssistantSuggestionsActions.fetchOne,
      { payload: { id: bannerSlotKey(slot), slot } },
      {
        successResponse: ({ store, action }) =>
          store.select(TellentAssistantSuggestionsSelectors.byId(action.payload.data.id)),
        failedResponse: ({ store, action }) =>
          store.select(TellentAssistantSuggestionsSelectors.error(action.payload.id)),
      },
    );
  }
}
